import { NgModule } from '@angular/core';
import { NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { ActivationLinkService } from './activation-link/services';

import { LeadService } from './lead/services';
import { DatepickerLocalFormatterService } from './trial-link/formatters/datepicker-local-formatter.service';
import { TrialService } from './trial/services';
import { TrustpilotService } from './trustpilot/services';

@NgModule({
  providers: [
    LeadService,
    TrialService,
    ActivationLinkService,
    {
      provide: NgbDateParserFormatter,
      useClass: DatepickerLocalFormatterService
    },
    TrustpilotService
  ]
})
export class DomainSalesModule { }
